/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAIcon16Light = forwardRef('MediaAudioMicAIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3ZM6 4a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0V4Z" }),
        React.createElement("path", { d: "M3.5 6a.5.5 0 0 1 .5.5V8a4 4 0 0 0 8 0V6.5a.5.5 0 0 1 1 0V8a5 5 0 0 1-4.5 4.975V15h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-2.025A5 5 0 0 1 3 8V6.5a.5.5 0 0 1 .5-.5Z" })));
});
